import { ComponentType, FC } from 'react';
import { useParams } from 'react-router';
import { CurrentPlanProjectionDetails, CurrentPlanProjections, NewInvestments } from '../../pages';

type NavSection = {
    element: ComponentType;
    subsections?: Record<string, NavSection>;
};

const createSection = (element: ComponentType, subsections?: Record<string, NavSection>): NavSection => ({
    element,
    ...(subsections && { subsections }),
});

const sections: Record<string, NavSection> = {
    'current-plan-projections': createSection(CurrentPlanProjections, {
        details: createSection(CurrentPlanProjectionDetails),
    }),
    'new-investments': createSection(NewInvestments),
};

export const PathResolver: FC = () => {
    const { section, subsection } = useParams<{
        section?: string;
        subsection?: string;
    }>();
    const Component =
        sections[section ?? '']?.subsections?.[subsection ?? '']?.element ?? sections[section ?? '']?.element;

    return Component ? <Component /> : null;
};
